export const STYLES = {
  PAGE_WRAPPER: 'absolute inset-0 z-[50] bg-bw00 h-screen w-screen flex flex-col fadeIn overflow-hidden',
  HEADER_WRAPPER: 'w-full py-[14px] px-[34px] flex items-center justify-between border-b border-bw03 relative',
  HEADER_TITLE: 'font-metricR text-[20px text-bw08] leading-[30px]',
  HEADER_ICON: 'w-[24px] cursor-pointer',
  BODY_WRAPPER: 'w-[375px] mx-auto flex flex-col items-center grow pt-[64px] fadeIn relative',
  BODY_TITLE: 'font-metricR text-[28px] text-bw08 mb-[16px] text-center leading-[128%]',
  FORM_DATA_WRAPPER: 'w-full grow relative',
  FLOATING_SCROLLABLE_DIV: 'absolute inset-0 flex flex-col items-center overflow-y-scroll pb-[14px]',
  FORM: 'w-[375px] flex flex-col gap-[26px]',
  INPUT_CLEAR_BUTTON: 'w-[28px] h-[28px] absolute right-[14px] top-[50%] translate-y-[-50%]',
  INPUT_CLEAR_BUTTON_CHILD: 'stroke-bw01 w-[100%] h-[100%]',
  COMBINE_FORM_INPUT: 'flex flex-row items-center justify-between gap-[24px] fadeIn',
  TAB_SWITCH_WRAPPER: 'w-[375px] relative mb-[12px] flex items-center bg-bw02 rounded-[8px] border border-bw03',
  TAB_SWITCH_COMMON: 'basis-1/2 pb-[14px] border-b hover:cursor-pointer',
  TAB_SWITCH_HEADER_COMMON: 'font-metricR text-[16px] hover:text-action03',
  FOOTER_WRAPPER: 'w-full flex items-center justify-center py-[24px] border-t border-bw03 fadeIn',
  FOOTER_BUTTON: 'text-sm text-bw00 rounded py-[18px] font-metricMedium w-full',
  FOOTER_BUTTON_DELETE:
    'text-sm text-red02 rounded py-[18px] max-w-[50%] min-w-[50%] w-[50%] bg-red00 font-metricMedium hover:bg-red01',
  SKELETON_WRAPPER: 'w-[375px] gap-[20px] flex flex-col',
  PICKER_TITLE: 'leading-[130%] font-metricR max-w-[380px] text-center text-[28px] text-bw08 mb-[16px]',
  PICKER_SUB_TITLE: 'font-metricR text-center text-[16px] text-bw07 mb-[22px]',
  PICKER_LOADER_SKELETON_WRAPPER: 'flex flex-col gap-[24px]',
  PICKER_COMPONENT_WRAPPER: 'w-full grow flex flex-col items-center',
  FILTER_LIST_WRAPPER: 'relative w-full mb-[16px]',
  FILTER_INPUT_ICON: 'w-[20px] absolute left-[14px] top-[50%] translate-y-[-50%]',
  FILTER_INPUT:
    'bg-bw02 placeholder-bw05 rounded-[8px] border w-full outline-none border-bw03 focus:border-bw07 font-metricR text-bw07 text-[16px] py-[10px] pr-[14px] pl-[42px]',
  SELECT_ICON: 'w-[18px] stroke-bw07 absolute right-[14px] top-[50%] translate-y-[-50%] z-50 cursor-pointer',
  PICKER: {
    ADD_NEW_PAYEE: {
      WRAPPER:
        'w-full flex items-center py-[10px] mb-[16px] ease-in duration-100 rounded-[8px] hover:px-[10px] hover:bg-bw02 cursor-pointer',
      ICON: 'w-[40px] mr-[8px]',
      TITLE: 'font-metricR text-[16px] text-bw08',
      ARROW: 'w-[24px] ml-auto text-bw08 mr-[8px]',
    },
    LIST: {
      TITLE: 'w-full font-metricR text-bw08 text-[16px] pb-[6px] mb-[12px] border-b border-bw03',
      WRAPPER_PLACEHOLDER: 'w-full grow relative',
      WRAPPER_SCROLLABLE: 'absolute inset-0 overflow-y-scroll flex flex-col no-scrollbar',
      PAYEE_BUTTON: 'w-full max-w-full hover:bg-bw02 rounded-[8px]',
      PAYEE_PREVIEW_WRAPPER:
        'w-full flex items-center py-[10px] rounded-[8px] ease-in duration-100 hover:px-[10px] hover:bg-bw02',
      PREVIEW_PROFILE:
        'rounded-[50%] relative min-w-[40px] w-[40px] h-[40px] flex items-center justify-center mr-[8px]',
      PREVIEW_OVERLAY: 'absolute inset-0 bg-bw08 rounded-[50%] transparent-gradient',
      PREVIEW_PROFILE_TITLE: 'font-metricRSemibold tracking-[-2px] text-bw00 text-[18px]',
      PREVIEW_NAME_AND_ADDRESS_WRAPPER: 'flex flex-col items-start ml-[8px]',
      PAYEE_NAME: 'font-metricR leading-[150%] text-[16px] text-bw08 max-w-[270px] truncate',
      PAYEE_ADDRESS_CONTAINER: 'flex items-center',
      PAYEE_ADDRESS_ICON: 'stroke-bw06 mr-[2px] w-[10px]',
      PAYEE_ADDRESS_TITLE: 'font-metricR text-[12px] leading-[150%] text-bw06 max-w-[80%] truncate',
      PAYEE_EDIT_BUTTON: 'ml-auto w-[40px] h-[40px] rounded-[50%] hover:bg-bw03 flex items-center justify-center',
      PAYEE_EDIT_ICON: 'min-w-[24px] w-[24px] stroke-bw08',
      ADD_PAYEE_FROM_KEYWORD_WRAPPER: 'w-full flex items-center justify-center py-[12px]',
      ADD_PAYEE_FROM_KEYWORD_BUTTON:
        'bg-action03 hover:bg-action04 text-bw00 font-metricR text-[16px] px-[50px] py-[12px] rounded max-w-[375px] truncate',
    },
  },
};

export const INPUTS_IDS = {
  BUSINESS_NAME: 'businessName',
  LINE_1: 'lineOne',
  LINE_2: 'lineTwo',
  ZIP_CODE: 'zipCode',
  CITY: 'city',
  STATE: 'state',
  WIRE_ACCOUNT_NUMBER: 'wireAccountNumber',
  WIRE_ROUTING_NUMBER: 'wireRoutingNumber',
  ACH_ACCOUNT_NUMBER: 'achAccountNumber',
  ACH_ROUTING_NUMBER: 'achRoutingNumber',
};

export const ELEMENT_IDS = {
  FORM: 'rhfWrapper',
  LABEL_CONTROLLER_WRAPPER: 'labelControllerWrapper',
  INPUT_ERROR: 'inputInlineError',
};

export const CONTEXT_TYPES = {
  MAIL_A_CHECK: 'MAIL_A_CHECK',
  ACH_OUT: 'ACH_OUT',
  BILL_PAY: 'BILL_PAY',
};

export const DYNAMIC_NAVIGATION_TITLE_MAP = {
  [CONTEXT_TYPES.MAIL_A_CHECK]: 'Mail a Check',
  [CONTEXT_TYPES.ACH_OUT]: 'Bank Transfer (ACH)',
};
export const DYNAMIC_TITLE_MAP = {
  [CONTEXT_TYPES.MAIL_A_CHECK]: 'Who would you like to send the check to?',
  [CONTEXT_TYPES.ACH_OUT]: 'Where would you like to transfer your money?',
};

export const DYNAMIC_SUB_TITLE_MAP = {
  [CONTEXT_TYPES.MAIL_A_CHECK]: 'Add new payee or choose from the list',
  [CONTEXT_TYPES.ACH_OUT]: 'Add new recipient or choose from the list',
};

export const SUPPLIER_COLOR_MAP = {
  0: '#64C4CE',
  1: '#FF8D9A',
  2: '#ED8D8D',
  3: '#B264CE',
  4: '#7278FF',
  5: '#EDCC8D',
  6: '#47B3EF',
  7: '#EF8347',
  8: '#EF4747',
};

export const SUPPLIER_REFERRER_TYPES = {
  MAIL_CHECK: 'MAIL_A_CHECK',
  ACH_OUT: 'ACH_OUT',
  ACH_OUT_MANDATORY: 'ACH_OUT_MANDATORY',
};

export const ACTION_TYPES = {
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  BACK: 'BACK',
};
